 (() => {
      const components = document.querySelectorAll('[data-description-toggle]');

      components.forEach((component) => {
        if (component.dataset.initialized === 'true') return;

        component.dataset.initialized = 'true';

        const inner = component.querySelector('.max-height--inner');
        const toggleButton = component.querySelector('[data-description-toggle-button]');
        const toggleLabel = component.querySelector('[data-description-toggle-label]');
        const accordionButtons = component.querySelectorAll('[data-description-accordion-button]');

        const updateOuterOverflow = () => {
          component.classList.remove('is-expanded');
          component.classList.add('is-collapsed');
          component.classList.add('is-ready');

          const isOverflowing = inner.scrollHeight > inner.clientHeight + 1;

          component.classList.toggle('is-overflowing', isOverflowing);

          if (!isOverflowing) {
            component.classList.remove('is-collapsed');
            component.classList.add('is-expanded');
          }
        };

        const setOuterExpanded = (expanded) => {
          component.classList.toggle('is-expanded', expanded);
          component.classList.toggle('is-collapsed', !expanded);
          toggleButton.setAttribute('aria-expanded', String(expanded));
          toggleLabel.textContent = expanded ? toggleButton.dataset.readLess : toggleButton.dataset.readMore;
        };

        accordionButtons.forEach((button) => {
          const panel = document.getElementById(button.getAttribute('aria-controls'));

          if (!panel) return;

          const setPanelExpanded = (expanded) => {
            button.classList.toggle('activ', expanded);
            button.setAttribute('aria-expanded', String(expanded));
            panel.style.maxHeight = expanded ? `${panel.scrollHeight}px` : null;
          };

          setPanelExpanded(button.classList.contains('activ'));

          button.addEventListener('click', () => {
            setPanelExpanded(button.getAttribute('aria-expanded') !== 'true');
            if (component.classList.contains('is-expanded')) {
              inner.style.maxHeight = 'none';
            }
          });
        });

        toggleButton.addEventListener('click', () => {
          setOuterExpanded(!component.classList.contains('is-expanded'));
        });

        updateOuterOverflow();
        window.addEventListener('resize', updateOuterOverflow);
      });
    })();